import React from "react";
import Analytics, { SHOW_PRODUCT } from "utils/analytics";
import { APPLICATION, PAGE } from "utils/constants/models";
import { usePageBuilderContext } from "utils/context";
import { useModelQueryId } from "utils/hooks";
import PATHS from "utils/paths";
import { interpolateRouteWithParams } from "utils/route";
import { SECTIONS } from "components/FormerEditor/utils";
import DraggableProductItem from "components/FormerEditor/BlockSettings/PricingTableBlock/ProductOrderSettings/DraggableProductItem";
import Link from "next/link";

const OffTableProductRow = (props) => {
  const { tracking } = usePageBuilderContext();
  const appId = useModelQueryId(APPLICATION);
  const pageId = useModelQueryId(PAGE);

  const productItemProps = {
    ...props,
    onClick: () => {
      Analytics.track(SHOW_PRODUCT, { ...tracking, product: props.uid });
    }
  };

  const destination = `${interpolateRouteWithParams(
    PATHS.APPLICATIONS_PAGES_SHOW_SECTION_PRODUCTS,
    {
      application: {
        uuid: appId
      },
      page: {
        uuid: pageId
      },
      section: {
        uuid: SECTIONS.PAGE_BUILDER
      },
      product: {
        uuid: props.uid
      }
    }
  )}`;

  return (
    <Link href={destination}>
      <DraggableProductItem {...productItemProps} />
    </Link>
  );
};
export default OffTableProductRow;
